import { Col, Row } from 'reactstrap';

const CycleIngenieur = () => {
    const UrlCycleIngenieur = process.env.REACT_APP_URL_CYCLE_INGENIEUR;
    return (
        <div>
            <hr class="mb-3" />
            <h1 className="mt-5 mb-5 color-green-eni spinnaker text-center fs-32">Plutôt intéressé·e par un Cycle Ingénieur 3iL Bac+5 en alternance ?</h1>
            <Row className="mb-5">
                <Col sm="12">
                    <div class="d-flex flex-column">
                        <div class="flex-fill">
                            <label class="lh-15 mt-3">Candidatez dès maintenant pour notre prochaine rentrée en septembre</label>
                            <a class="btn btn-outline-green-eni border-outline-green-eni btn-contour-droit fs-20 lh-15 p-3 m-3" href={UrlCycleIngenieur}>Je candidate</a>
                        </div>
                    </div>
                </Col>
            </Row>
        </div>    
    );
}

export default CycleIngenieur;